import clsx from 'clsx';
import { type HTMLAttributes, Fragment, createElement } from 'react';

const sizes = {
  "sm": "text-sm md:text-base font-medium", // pc 14px
  "md": "text-base font-medium", // pc 16px
  "lg": "text-base md:text-xl font-semibold", // pc 20px
  "xl": "text-xl md:text-2xl font-semibold", // pc 24px
  "2xl-s": "text-xl md:text-2xl lg:text-3xl font-bold md:!leading-tight tracking-tight", // pc 30px
  "2xl": "text-2xl md:text-3xl lg:text-4xl font-extrabold md:!leading-tight tracking-tight", // pc 36px
  "3xl-s": "text-32 md:text-40 lg:text-5xl font-extrabold tracking-tight", // pc 48px
  "3xl": "text-32 md:text-40 lg:text-50 font-extrabold tracking-tight", // pc 50px
  "4xl": "text-3xl md:text-4xl lg:text-62 font-extrabold tracking-tight", // pc 64px
  "5xl": "text-3xl md:text-4xl lg:text-66 font-extrabold tracking-tight", // pc 70px
};
type Headline = 'h1'|'h2'|'h3'|'h4'|'h5'|'h6';
export interface Props extends HTMLAttributes<Headline> {
  size?: keyof typeof sizes;
  tag?: Headline;
}

const Headline:React.FC<Props> = function Headline({tag = "h2", size = "2xl", className, children, ...props}) {
  const Tag = createElement(tag, { key: tag, className: clsx(sizes[size], className), ...props }, children);
  return <Fragment>{Tag}</Fragment>;
}
export default Headline;